import { Flex, Spacer, Text, Wrap } from '@chakra-ui/react';

import { shadowStyles } from '@aslanpay/portal-common-lib';
import { getBulkActionsValues } from 'app/utils/table';

import { BulkActionsProps } from './types';

function BulkActions<TData extends object>({
  type,
  actions,
  selectedRows,
}: BulkActionsProps<TData>) {
  const bulkActionsValues = getBulkActionsValues(type, actions, selectedRows);

  return (
    <Flex
      width="full"
      gap="10px"
      px="10px"
      alignItems="center"
      borderRadius="10px"
      boxShadow={shadowStyles.dropdownMenu}
      bgColor="brand.mutedPurple"
      color="brand.white"
      position="sticky"
      bottom="40px"
      zIndex="bulkActions"
    >
      <Text
        minW="40px"
        p="10px"
        borderRadius="5px"
        bgColor="brand.purple"
        textAlign="center"
        textStyle="h5SemiBold"
      >
        {selectedRows.length}
      </Text>
      <Text textStyle="h6Medium">{`${bulkActionsValues?.label}s selected`}</Text>
      <Spacer />
      <Wrap>{bulkActionsValues?.bulkActions?.map((bulkAction) => bulkAction)}</Wrap>
    </Flex>
  );
}

export default BulkActions;
